export default {
  navHome: "Home",
  navProducts: "Products",
  navCases: "Application Cases",
  navAbout: "About",
  deliverTo: "Deliver to:",
  langCurrencyLabel: "English",
  localeLangTitle: "Set language",
  localeLangDesc:
    "Select your preferred language. The site URL will update to match.",
  language: "Language",
  save: "Save",
  uiClose: "Close",
  carouselPrev: "Previous product",
  carouselNext: "Next product",
  heroSlidePrev: "Previous slide",
  heroSlideNext: "Next slide",
  heroSlideDot: "Go to slide {n}",
  coreProducts: "Empowering Real-World Creation.",
  coreProductsDesc:
    "From ideas to business �?YONGYUAN provides UV printers, crystal label printers, high-speed cylindrical printers, DTF printers, and DTG printers, transforming creativity into products, brands, and opportunities.",
  scenariosTitle: "Empowering Every Scenario",
  scenariosDesc:
    "Whether you are building a brand, developing a side business, or pursuing creative passions, YONGYUAN offers a solution tailored to your needs.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "High-value customization, small-batch prototyping, and brand building",
  scenarioRetail: "Brand Retail",
  scenarioRetailDesc:
    "Extend customer dwell time and increase in-store revenue",
  scenarioMarket: "Pop-up Market",
  scenarioMarketDesc:
    "On-site customization, finished-goods sales, and side-business income",
  scenarioEnterprise: "Enterprise Customization",
  scenarioEnterpriseDesc:
    "Batch customization, branded merchandise, and corporate gifts",
  scenarioEcommerce: "Livestream Selling",
  scenarioEcommerceDesc:
    "Hit-product sampling, flexible supply, and rapid product launches",
  scenarioStore: "E-commerce Store",
  scenarioStoreDesc:
    "Store customization, hit-product merchandise, and differentiated operations",
  scenarioFactory: "Factory Production",
  scenarioFactoryDesc:
    "Batch manufacturing, stable output, and cost-efficient operations",
  scenarioAdvertising: "Advertising Production",
  scenarioAdvertisingDesc:
    "Signage, display materials, and event collateral",
  industries: "Industry Applications",
  industriesDesc:
    "Digital inkjet printing solutions for color printing across industries.",
  applicationsTitle:
    "Unlock Versatile Material and Color Applications for Everyday and Commercial Needs.",
  applicationsDesc:
    "YONGYUAN UV printing equipment is engineered for a wide range of materials and process scenarios, empowering both personalized customization and large-scale production.",
  casesHeroDesc: "Showcasing 1000+ product application scenarios",
  casesBreadcrumbHome: "Home",
  casesBreadcrumbCenter: "Application Cases",
  casesEmpty: "No application cases in this category yet.",
  customerStoriesTitle: "Trusted by Customers Worldwide",
  customerStoriesSubtitle:
    "Real installations, real customers, real printing businesses across 172 countries.",
  customerStoriesTrustedTitle: "Trusted Worldwide",
  customerStoriesStat1Value: "53,000+",
  customerStoriesStat1Label: "Printers Delivered",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Countries Served",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Years Experience",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Technical Support",
  customerStoriesBadge: "{count} international customer photos showcased",
  customerStoriesPlaceholder: "Add customer photo",
  customerStoriesPhotoAlt: "YONGYUAN customer with printer",
  customerStoryCountryUsaNewYork: "New York, USA",
  customerStoryCountryGermany: "Germany",
  customerStoryCountryThailand: "Thailand",
  customerStoryCountrySpain: "Spain",
  customerStoryCountryBrazil: "Brazil",
  customerStoryCountryAustralia: "Australia",
  customerStoryCountrySaudiArabia: "Saudi Arabia",
  customerStoryCountrySingapore: "Singapore",
  customerStoryCountryKorea: "South Korea",
  customerStoryCountryIsrael: "Israel",
  customerStoryCountryKazakhstan: "Kazakhstan",
  customerStoryCountryMexico: "Mexico",
  customerStoryCountryArgentina: "Argentina",
  customerStoryCountryPhilippines: "Philippines",
  customerStoryCountryIndonesia: "Indonesia",
  customerStoryCountryNetherlands: "Netherlands",
  customerStoryCountrySweden: "Sweden",
  customerStoryCountrySouthAfrica: "South Africa",
  customerStoryCountryMalaysia: "Malaysia",
  customerStoryCountryTaiwan: "Taiwan",
  customerStoryCountryUsa: "United States",
  customerStoryCaption01: "USA�?090 UV Printer",
  customerStoryCaption02: "Germany｜F33 DTF Printer",
  customerStoryCaption03: "Thailand�?250 UV Printer",
  customerStoryCaption04: "Spain�?250 UV Printer",
  customerStoryCaption05: "Brazil�?030 UV Printer",
  customerStoryCaption06: "Australia｜F33 DTF Printer",
  customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
  customerStoryCaption08: "Singapore｜F33 DTF Printer",
  customerStoryCaption09: "South Korea｜F33 DTF Printer",
  customerStoryCaption10: "Israel｜UVC33 DTF Printer",
  customerStoryCaption11: "Kazakhstan�?030 UV Printer",
  customerStoryCaption12: "Mexico�?060 UV Printer",
  customerStoryCaption13: "Argentina�?060 UV Printer",
  customerStoryCaption14: "Philippines�?090 UV Printer",
  customerStoryCaption15: "Indonesia�?030 UV Printer",
  customerStoryCaption16: "Netherlands�?030 UV Printer",
  customerStoryCaption17: "Sweden�?060 UV Printer",
  customerStoryCaption18: "Germany�?030 UV Printer",
  customerStoryCaption19: "South Africa�?030 UV Printer",
  customerStoryCaption20: "Malaysia｜F33 DTF Printer",
  customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
  customerStoryCaption22: "USA｜F70Pro DTF Printer",
  customerStoryCaption23: "USA�?513 UV Printer",
  customerStoryCaption24: "USA�?090 UV Printer",
  customerStoryCaption25: "USA�?030 UV Printer",
  customerStoryCaption26: "USA�?250 UV Printer",
  customerStoryCaption27: "South Korea�?060 UV Printer",
  customerStoryCaption28: "Netherlands�?060 UV Printer",
  servicePartnerTitle:
    "Meet the YONGYUAN Service Team, Your Creative Partner",
  servicePartnerDesc:
    "A global service network and professional support system to safeguard your equipment performance and business growth.",
  serviceSupportTitle: "Standard Support",
  serviceSupportDesc:
    "Installation guidance, foundational training, and day-to-day usage assistance to keep your equipment running reliably.",
  servicePresaleTitle: "Pre-Sales Demo & Consultation",
  servicePresaleDesc:
    "Solution demonstrations and model recommendations tailored to your application scenarios and capacity requirements.",
  serviceLifetimeTitle: "Lifetime Technical Support",
  serviceLifetimeDesc:
    "Ongoing technical response and process support to accompany your long-term business development.",
  serviceCareTitle: "Upgrade to YONGYUAN Care",
  serviceCareDamageTitle: "Accidental Damage Protection",
  serviceCareDamageDesc:
    "A more comprehensive protection plan to reduce losses caused by unexpected incidents.",
  serviceCareExchangeTitle: "Fast Trade-In Service",
  serviceCareExchangeDesc:
    "Priority fast trade-in arrangements under eligible conditions to accelerate capital recovery.",
  viewProduct: "View Products",
  learnMore: "Learn More",
  catUv: "UV Flatbed Printer",
  catUvNav: "UV Flatbed",
  catCylinder: "Cylindrical Printer",
  catCylinderNav: "Cylindrical",
  catCrystal: "Crystal Label Printer",
  catCrystalNav: "Crystal Label",
  catDtf: "DTF Printer",
  catDtfNav: "DTF",
  catDtg: "DTG Printer",
  catDtgNav: "DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Phone: 17748697567 Manager Tang",
  email: "Email: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. All rights reserved",
  productsHeroTitle: "Products",
  productsHeroDesc:
    "A complete lineup of UV flatbed, cylindrical, UV DTF, crystal label, DTF, and DTG equipment for personalized customization, batch production, and industrial applications.",
  productsBreadcrumbHome: "Home",
  productsBreadcrumbCenter: "Products",
  productsEmpty: "Products in this category are coming soon.",
  productsQuoteTitle: "Request a Solution & Quotation",
  productsQuoteDesc:
    "Share your application scenarios and capacity requirements, and we will recommend the right equipment solution for you.",
  productsContact: "Contact Us",
  aboutHeroTitle: "About Yongyuan",
  aboutHeroDesc: "23 years focused on UV printing equipment R&D and production",
  productA23Subtitle: "Compact Desktop UV Printing Solution",
  productA23Industry:
    "Best for: Custom Phone Cases | Keychains & Badges | Small Promo Gifts | Studio Sampling | etc.",
  productA23Feature1: "20×30cm Format",
  productA23Feature2: "6-Color Precision Printing",
  productA23Feature3: "IR Auto Height Detection",
  productA35Subtitle: "Desktop UV Flatbed Printing Solution",
  productA35Industry:
    "Best for: Medals & Trophies | Leather Card Holders | Cosmetic Boxes | Acrylic Keepsakes | etc.",
  productA35Feature1: "32×50cm Format",
  productA35Feature2: "6-Color Smart Ink System",
  productA35Feature3: "IR Auto Height Detection",
  productA43Subtitle: "Commercial A3 UV Printing Solution",
  productA43Industry:
    "Best for: Wood Nameplates | Acrylic Wayfinding | UV DTF Films | Small Packaging Prototypes | etc.",
  productA43Feature1: "40×30cm Print Format",
  productA43Feature2: "8-Color Options",
  productA43Feature3: "Multi-Material Ready",
  productA46Subtitle: "Commercial A2 UV Printing Solution",
  productA46Industry:
    "Best for: Light Panels | Gift Box Printing | Glass Crafts | Creative Merch Short Runs | etc.",
  productA46Feature1: "40×60cm Print Format",
  productA46Feature2: "8-Color Options",
  productA46Feature3: "Stable Mass Production",
  productA57Subtitle: "A2+ Format UV Flatbed Printing Solution",
  productA57Industry:
    "Best for: Luggage Panels | Decorative Art | Tile Prints | Mid-Size Craft Customization | etc.",
  productA57Feature1: "50×70cm Format",
  productA57Feature2: "8-Color Options",
  productA57Feature3: "High-Detail Reproduction",
  productA69Subtitle: "Commercial A1 Large-Format UV Printing Solution",
  productA69Industry:
    "Best for: Furniture Panels | Glass Sliding Doors | Plastic/Metal Sheets | Display Boards | etc.",
  productA69Feature1: "60×90cm Print Format",
  productA69Feature2: "8-15 Color Options",
  productA69Feature3: "Industrial-Grade Stability",
  productA1216Subtitle: "Super Wide-Format Industrial UV Solution",
  productA1216Industry:
    "Best for: KT Displays | Storefront Signs | Lightboxes | Mall Wayfinding & Feature Walls | etc.",
  productA1216Feature1: "120×160cm Format",
  productA1216Feature2: "Visual Positioning System",
  productA1216Feature3: "Multi-Head Production Setup",
  productA2513Subtitle: "Flagship Industrial UV Flatbed Solution",
  productA2513Industry:
    "Best for: Doors & Cabinets | Home Decor Panels | Full Feature Walls | Ad & Interior Batch Runs | etc.",
  productA2513Feature1: "250×130cm Format",
  productA2513Feature2: "Visual Positioning System",
  productA2513Feature3: "Continuous Batch Production",
  productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
  productA3220Industry:
    "Best for: Full Stone Slabs | Large Architectural Glass | Building Panels | Premium Wall Customization | etc.",
  productA3220Feature1: "320×200cm Print Format",
  productA3220Feature2: "Visual Positioning System",
  productA3220Feature3: "Continuous Batch Production",
  productCylinderElfSubtitle: "High-Speed Cylindrical Printing Solution",
  productCylinderElfIndustry:
    "Best for: Tumbler Wrap Prints | Wine Bottles | Cosmetic Bottles | Small-Batch Cup Gifts | etc.",
  productCylinderElfFeature1: "360° Printing",
  productCylinderElfFeature2: "Cup & Bottle Customization",
  productCylinderElfFeature3: "Quick Fixture Changeover",
  productCupPlusSubtitle: "Multi-Size Cylindrical Printing Solution",
  productCupPlusIndustry:
    "Best for: Tumbler Batch Runs | Wine/Perfume Bottles | Corporate Gifts | Seamless 360° Printing | etc.",
  productCupPlusFeature1: "Multi-Size Fixtures",
  productCupPlusFeature2: "High Production Efficiency",
  productCupPlusFeature3: "Stable Output",
  productCrystal60Subtitle: "Commercial Crystal Label Printing Solution",
  productCrystal60Industry:
    "Best for: Apparel Labels | Packaging Domes | Glass/Metal Transfers | Promo Gift Marks | etc.",
  productCrystal60Feature1: "60cm Width",
  productCrystal60Feature2: "Print & Foil in One",
  productCrystal60Feature3: "Efficient Take-up",
  productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
  productCrystal60UltraIndustry:
    "Best for: Brand Packaging Domes | Foil Labels | Gift Finishing | High-Volume Continuous Transfer | etc.",
  productCrystalC60UltraFeature1: "60cm Width",
  productCrystalC60UltraFeature2: "Gold/Silver/3D Labels",
  productCrystalC60UltraFeature3: "Continuous Batch Output",
  productCrystal30Subtitle: "Compact Crystal Label Printing Solution",
  productCrystal30Industry:
    "Best for: Phone Case Transfers | Creative Mini Labels | Sample Labels | Multi-SKU Small Batches | etc.",
  productCrystal30Feature1: "30cm Width",
  productCrystal30Feature2: "High-Precision Labels",
  productCrystal30Feature3: "Easy Operation",
  productDtf60Subtitle: "White Ink DTF Transfer Printer",
  productDtf60Feature1: "White Ink DTF Transfer",
  productDtf60Feature2: "Rich Color Layers",
  productDtf60Feature3: "Apparel Accessories",
  productDtfF20Subtitle: "Desktop White Ink DTF Printing Solution",
  productDtfF20Industry:
    "Best for: Custom T-Shirts | Studio Startups | Quick Small Runs | Hoodie Transfers | etc.",
  productDtfF20Feature1: "A4 Print Size",
  productDtfF20Feature2: "White + Color in One",
  productDtfF20Feature3: "Smart Ink System",
  productDtfF30Subtitle: "Commercial White Ink DTF Printing Solution",
  productDtfF30Industry:
    "Best for: Apparel Shops | E-Commerce Quick Turn | Team Uniforms | Short-Run Tees | etc.",
  productDtfF30Feature1: "A3 Print Size",
  productDtfF30Feature2: "Manual/Auto Single Head",
  productDtfF30Feature3: "Smart Ink System",
  productDtfF30ProSubtitle: "High-Efficiency White Ink DTF Solution",
  productDtfF30ProIndustry:
    "Best for: Garment Factories | Bulk Heat Transfer | Brand OEM | Continuous Shop Orders | etc.",
  productDtfF30ProFeature1: "A3 Dual Printheads",
  productDtfF30ProFeature2: "Auto Film Take-up",
  productDtfF30ProFeature3: "Smart Ink System",
  productDtfF33Subtitle: "Flexible White Ink DTF Printing Solution",
  productDtfF33Industry:
    "Best for: Custom Stores | Creative Merch | Mid-Volume Transfers | Mixed Apparel Orders | etc.",
  productDtfF33Feature1: "A3 Print Size",
  productDtfF33Feature2: "Flexible Workstation Setup",
  productDtfF33Feature3: "Smart Ink System",
  productDtfF70ProSubtitle: "Industrial Wide-Format White Ink DTF Solution",
  productDtfF70ProIndustry:
    "Best for: Garment Plant Lines | Wide Transfers | Bulk Orders | Continuous Feed Production | etc.",
  productDtfF70ProFeature1: "70cm Print Width",
  productDtfF70ProFeature2: "2-4 Printhead Options",
  productDtfF70ProFeature3: "Auto Feed and Resume Printing",
  productDtf30Subtitle: "Compact White Ink DTF Printer",
  productDtf30Feature1: "Small-Batch Customization",
  productDtf30Feature2: "Accurate Color Reproduction",
  productDtf30Feature3: "Easy to Use",
  productDtgPrintSubtitle: "Digital Direct-to-Garment Printer",
  productDtgPrintFeature1: "Multi-Material Direct Printing",
  productDtgPrintFeature2: "High Throughput",
  productDtgPrintFeature3: "Stable & Durable",
  productDtg3250DSubtitle: "DTF & DTG 2-in-1 Printing Solution",
  productDtg3250DIndustry:
    "Best for: Apparel Retail | DTF + DTG in One | Flexible Orders | One-Piece MOQ | etc.",
  productDtg3250DFeature1: "A3+ Print Format",
  productDtg3250DFeature2: "DTF/DTG Dual Mode",
  productDtg3250DFeature3: "Smart Ink System",
  productDtg3646TSubtitle: "Dual-Station DTG Direct Printing Solution",
  productDtg3646TIndustry:
    "Best for: Tee & Hoodie Direct Print | Bulk Culture Shirts | Live-Commerce Supply | Dual-Station Output | etc.",
  productDtg3646TFeature1: "Dual-Station Continuous Run",
  productDtg3646TFeature2: "100% Productivity Boost",
  productDtg3646TFeature3: "Smart Ink System",
  productDtgMaxSubtitle: "Industrial Digital DTG Printer",
  productDtgMaxFeature1: "Industrial Capacity",
  productDtgMaxFeature2: "Stable & Durable",
  productDtgMaxFeature3: "Continuous Operation",
  app01Title: "Phone Cases",
  app02Title: "Golf Balls",
  app03Title: "Stone Plaques",
  app04Title: "Ballpoint Pens",
  app05Title: "Glasses Cases",
  app06Title: "Woodblock Prints",
  app07Title: "Beverage Cans",
  app08Title: "Keyboards",
  app09Title: "Tumblers",
  app10Title: "Luggage",
  app11Title: "Acrylic Products",
  app12Title: "Notebooks",
  app13Title: "Badges",
  app14Title: "Leather Card Holders",
  app15Title: "Dog Tags",
  app16Title: "Glass Art",
  appDtgCase01: "T-Shirts",
  appDtgCase02: "Hoodies",
  globeTapHint: "Tap a country to explore",
  regionCn: "China",
  regionUs: "United States",
  regionGb: "United Kingdom",
  regionDe: "Germany",
  regionAe: "UAE",
  regionIn: "India",
  regionJp: "Japan",
  regionVn: "Vietnam",
  regionBr: "Brazil",
  regionAu: "Australia",
  cityShanghai: "Shanghai",
  cityShenzhen: "Shenzhen",
  cityDetroit: "Detroit",
  cityManchester: "Manchester",
  cityStuttgart: "Stuttgart",
  cityDubai: "Dubai",
  cityPune: "Pune",
  cityOsaka: "Osaka",
  cityHoChiMinh: "Ho Chi Minh City",
  citySaoPaulo: "São Paulo",
  cityMelbourne: "Melbourne",
};
